import { get } from "lodash";
const defaultState = {
    fetching: false,
    error: false,
    status: false,
    servererror: [],
    data: [],
    authenticated: false
}

export default function loginReducer(state = defaultState, action) {
    switch (action.type) {
        case "SUBMIT_LOGIN_PENDING": {
            return { ...defaultState, fetching: true }
        }
        case "SUBMIT_LOGIN_REJECTED": {
            return { ...state, fetching: false, data: action.payload.data }
        }
        case "SUBMIT_LOGIN_FULFILLED": {
            let data = action.payload.data;
            let code = get(data, "status");
            return {
                ...state,
                fetching: false,
                status: code,
                data: data.data,
                servererror: code !== 200 ? data.data : []
            }
        }
        case "SUBMIT_FORGOT_PENDING": {
            return { ...defaultState, fetching: true, data: [] }
        }
        case "SUBMIT_FORGOT_REJECTED": {
            return { ...state, fetching: false, data: action.payload.data }
        }
        case "SUBMIT_FORGOT_FULFILLED": {
            let data = action.payload.data;
            let code = get(data, "status");
            return {
                ...state,
                fetching: false,
                status: code,
                data: data.data,
                servererror: code !== 201 ? data.data : []
            }
        }
        case "SUBMIT_RESET_PENDING": {
            return { ...state, fetching: true, data: [] }
        }
        case "SUBMIT_RESET_REJECTED": {
            return { ...state, fetching: false, data: action.payload.data }
        }
        case "SUBMIT_RESET_FULFILLED": {
            let data = action.payload.data;
            let code = get(data, "status");
            return {
                ...state,
                fetching: false,
                status: code,
                data: data.data,
                servererror: code !== 204 ? data.data : []
            }
        }
        case "AUTHENTICATE_RESET_PENDING": {
            return { ...defaultState, fetching: true }
        }
        case "AUTHENTICATE_RESET_REJECTED": {
            return { ...state, fetching: false }
        }
        case "AUTHENTICATE_RESET_FULFILLED": {
            let data = action.payload.data;
            let code = get(data, "status");
            return {
                ...state,
                fetching: false,
                status: code,
                authenticated: code === 201 ? true : false
            }
        }
        case "RESET_LOGIN": {
            return {
                ...state,
                fetching: false,
                error: false,
                status: false,
                servererror: [],
                data: [],
                authenticated: false
            }
        }
        default: {
            return state;
        }
    }
}